"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavItem;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
var _theme = _interopRequireDefault(require("../../theme"));
function NavItem(props) {
  const {
    label,
    icon,
    iconColor,
    children: childrenProps,
    disabled,
    selected,
    onClick,
    id,
    isFooter,
    href
  } = props;
  const children = href ? null : childrenProps;
  const hasChildrenSelected = (0, _react.useCallback)(() => {
    if (children && children.props && children.props.children) {
      const subChildren = children.props.children;
      if (Array.isArray(subChildren)) {
        return subChildren.some(subChild => subChild.props && subChild.props.selected);
      }
      return subChildren.props && subChildren.props.selected;
    }
    return false;
  }, [children]);
  _react.default.useEffect(() => {
    if (hasChildrenSelected()) {
      setOpen(true);
    }
  }, [children, hasChildrenSelected, selected]);
  const [open, setOpen] = _react.default.useState(hasChildrenSelected());
  const onClickHandler = () => {
    if (!disabled) {
      setOpen(!open || hasChildrenSelected());
      if (onClick) {
        onClick(!open);
      }
    }
  };
  const customLabel = typeof label !== 'string';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "\n        nav-item \n        ".concat(selected ? 'nav-item--selected' : '', "\n        ").concat(hasChildrenSelected() ? 'nav-item--children-selected' : '', "\n        ").concat(isFooter ? 'nav-item--footer' : '', "\n        ").concat(children ? 'nav-item--has-children' : '', "\n      ")
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "\n          ".concat(customLabel ? 'nav-item-custom-content' : 'nav-item-content', "\n          ").concat(disabled ? 'nav-item--disabled' : '', "\n        "),
    onClick: onClickHandler,
    id: id
  }, icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon,
    className: "nav-item--icon",
    fillColor: iconColor !== null && iconColor !== void 0 ? iconColor : _theme.default.palette.TwClrIcnSecondary
  }), !href && /*#__PURE__*/_react.default.createElement("span", {
    className: "nav-item--label"
  }, label), href && /*#__PURE__*/_react.default.createElement("a", {
    className: "nav-item--label nav-item--anchor",
    href: href,
    rel: "noopener noreferrer",
    target: "_external"
  }, label), children && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: open ? 'chevronUp' : 'chevronDown',
    className: "nav-item--arrow"
  })), children && open && children);
}